import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="dr-shell flex min-h-screen items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-zinc-900">
          <XCircle size={44} className="text-zinc-500" />
        </div>
        <h1 className="mt-6 font-display text-4xl text-white">Checkout cancelled</h1>
        <p className="mt-3 text-sm text-zinc-400">No charge made. Come back anytime today.</p>
        <Link
          to="/"
          className="dr-btn-primary mt-8 inline-flex rounded-full px-8 py-3"
          data-testid="cancel-back-home"
        >
          Back to card
        </Link>
      </div>
    </div>
  );
}
